import React from "react";
import { toast } from "react-toastify";

// Hook

// Helper
import { hasUserMedia } from "../helpers/appHelper";

const startCamera = async (setCamReady, setCamStream, setCamError) => {
  const constraints = {
    audio: false,
    video: true,
  };

  toast.promise(navigator.mediaDevices.getUserMedia(constraints), {
    pending: "Accessing camera...",
    success: {
      render: ({ data }) => {
        setCamStream(data);
        setCamReady(true);

        return "Camera is ready";
      },
    },
    error: {
      render: (err) => {
        setCamError(err);

        return "Error accessing camera, please allow camera access";
      },
    },
  });
};

const stopCamera = (camStream, setCamReady) => {
  if (camStream) {
    setCamReady(false);
    camStream.getTracks().forEach((track) => track.stop());

    toast.info("Camera is off");
  }
};

const useCamera = (camVideoRef) => {
  const [camReady, setCamReady] = React.useState(false);
  const [camStart, setCamStart] = React.useState(false);
  const [camError, setCamError] = React.useState("");
  const [camStream, setCamStream] = React.useState(null);

  React.useEffect(() => {
    if (!hasUserMedia()) return;

    if (!camStart || camReady) return;

    startCamera(setCamReady, setCamStream, setCamError)
      .then((stream) => {
        setCamReady(true);

        return { camStream: stream };
      })
      .catch((err) => {
        setCamError(err);

        return { camError: err };
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [camReady, camStart]);

  React.useEffect(() => {
    const camVideo = camVideoRef.current;

    if (!camVideo) return;

    if (camStart) {
      camVideo.srcObject = camStream;
    } else {
      stopCamera(camStream, setCamReady);
      camVideo.srcObject = null;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [camStart, camStream, camVideoRef]);

  return { camStart, setCamStart, camError };
};

export { useCamera };
